<app-page-loading></app-page-loading>

<app-toast-message></app-toast-message>

<div class="main-wrapper" [ngClass]="{ 'bg-white' : !isLoggedIn }">
   <router-outlet></router-outlet>
</div>